var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("keep-alive", [
    _c("div", { staticClass: "uni-header" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "shool-box" }, [
          _vm.background
            ? _c("img", {
                staticClass: "school-img",
                attrs: { src: _vm.background, alt: "图片加载失败" },
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "content" },
            [
              _vm.logo
                ? _c("el-image", {
                    staticStyle: { "max-height": "90%", "max-width": "300px" },
                    attrs: { src: _vm.logo, alt: "图片加载失败", lazy: "" },
                  })
                : _vm._e(),
              _c("div", { staticClass: "msg-box" }, [
                _c("p", { staticClass: "txt" }, [
                  _vm._v(_vm._s(_vm.userInfo.title) + "，欢迎您！"),
                ]),
                _c(
                  "p",
                  { staticStyle: { "margin-top": "9px" } },
                  [
                    _c("span", [_vm._v("当前班级")]),
                    _c(
                      "el-select",
                      {
                        staticClass: "uni-select",
                        attrs: {
                          placeholder: "请选择班级",
                          defaultFirstOption: true,
                        },
                        on: { change: _vm.changeHandler },
                        model: {
                          value: _vm.major,
                          callback: function ($$v) {
                            _vm.major = $$v
                          },
                          expression: "major",
                        },
                      },
                      _vm._l(_vm.userInfo.classList, function (item) {
                        return _c("el-option", {
                          key: item.class_id,
                          attrs: {
                            value: item.class_id,
                            label: item.className,
                          },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "weather-box" }, [
          _c("p", { staticClass: "date" }, [
            _vm._v(
              " " +
                _vm._s(_vm.date.getFullYear()) +
                "年 " +
                _vm._s(_vm.date.getMonth() + 1) +
                "月 " +
                _vm._s(_vm.date.getDate()) +
                "日 星期" +
                _vm._s(_vm._f("dayFilter")(_vm.date.getDay())) +
                " "
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }